import React, { Component } from 'react';
import { getUserNameAndSurname } from '../../../utils';
import withTranslations from '../../../utils/HighOrderComponent';

class ComplementRequestHistoryRow extends Component {
  render() {
    const { index, complementRequest } = this.props || {},
      { description, creator, createdAt, requestForSignetApproval } =
        complementRequest || {};

    const complementRequestCreator = getUserNameAndSurname(creator);
    const requestClientName = getUserNameAndSurname(
      requestForSignetApproval?.client
    );

    const complementRequestHistoryRow = (
      <tr className="text-center">
        <td>{index}</td>
        <td>{description}</td>
        <td>{requestClientName}</td>
        <td>{complementRequestCreator}</td>
        <td>{createdAt}</td>
      </tr>
    );

    return complementRequestHistoryRow;
  }
}

export default withTranslations(
  ComplementRequestHistoryRow,
  'ComplementRequestHistoryRow'
);
